import Header from "./Header";
import MenuItem from "components/MenuItem";
import PropTypes from "prop-types";
import React from "react";
import Section from "components/Section";
import { TextTitle } from "components/Texts";
import AccountSelector from "components/AccountSelector";
import colors from "styles/colors";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import useWindowSize from "../layout/useWindowSize";
import { useSelector } from "react-redux";
import mainSelectors from "modules/main/selectors";
import googleSelectors from "modules/google/selectors";

const Sidebar = ({ isVisible, onBackdropClicked }) => {
  const currentDashboard = useSelector((state) => mainSelectors.currentDashboardResult(state));
  const authAdproResult = useSelector((state) => mainSelectors.authAdproResult(state));
  const RcrmAppAvailableResult = useSelector((state) => mainSelectors.checkAppAvailableResult(state));
  const businessInfoResult = useSelector((state) => googleSelectors.getBusinessInfoResult(state));
  const { REACT_APP_ENABLE_GOOGLE, REACT_APP_ENABLE_GOOGLE_WHITELIST } = process.env;

  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();
  const windowSize = useWindowSize();

  let menuItems =
    currentDashboard.data.dashboard == "google" ? (
      <>
        {authAdproResult.data.adwords_managed_service === "Y" ? (
          <>
            <MenuItem
              route="/dashboard"
              text={t("__dashboard")}
              onClick={onBackdropClicked}
              padding="10px 10px 10px 11px"
            />
            <MenuItem
              route="/adpro-suggestions"
              text={t("__adpro_suggestion")}
              onClick={onBackdropClicked}
              padding="10px 10px 10px 11px"
            />
            <MenuItem
              route="/account-performance"
              text={t("__account_performance")}
              onClick={onBackdropClicked}
              padding="10px 10px 10px 11px"
            />
            <MenuItem
              route="/search-campaigns"
              text={t("__search_campaign")}
              onClick={onBackdropClicked}
              padding="10px 10px 10px 11px"
            />
            <MenuItem
              route="/display-campaigns"
              text={t("__display_campaign")}
              onClick={onBackdropClicked}
              padding="10px 10px 10px 11px"
            />
            <MenuItem
              route="/payment"
              text={t("__payment")}
              onClick={onBackdropClicked}
              padding="10px 10px 10px 11px"
            />
            <MenuTitleZone>
              <TextTitle color={colors.subText} size="12px">
                {t("__conversion_header")}
              </TextTitle>
            </MenuTitleZone>
            <MenuItem
              route="/rmp-conversions/r-widget"
              text={t("__r_widget_conversions")}
              onClick={onBackdropClicked}
            />
            {RcrmAppAvailableResult &&
            RcrmAppAvailableResult.result === 0 &&
            RcrmAppAvailableResult.data &&
            RcrmAppAvailableResult.data.foundApp ? (
              <MenuItem route="/rmp-conversions/r-crm" text={t("__r_crm_conversions")} onClick={onBackdropClicked} />
            ) : (
              ""
            )}
            {(REACT_APP_ENABLE_GOOGLE == "TRUE" ||
              (businessInfoResult?.data?.business_id &&
                REACT_APP_ENABLE_GOOGLE_WHITELIST.search(businessInfoResult?.data?.business_id) >= 0)) && (
              <MenuItem
                route="/rmp-conversions/google-sheets"
                text={t("__google_sheets_conversions")}
                onClick={onBackdropClicked}
              />
            )}
          </>
        ) : (
          <>
            <MenuItem
              route="/dashboard/self-service"
              text={t("__dashboard")}
              onClick={onBackdropClicked}
              padding="10px 10px 10px 11px"
            />
            <MenuItem
              route="/account-performance/self-service"
              text={t("__account_performance")}
              onClick={onBackdropClicked}
              padding="10px 10px 10px 11px"
            />
            <MenuTitleZone>
              <TextTitle color={colors.subText} size="12px">
                {t("__conversion_header")}
              </TextTitle>
            </MenuTitleZone>
            <MenuItem
              route="/rmp-conversions/r-widget"
              text={t("__r_widget_conversions")}
              onClick={onBackdropClicked}
            />
            {RcrmAppAvailableResult &&
            RcrmAppAvailableResult.result === 0 &&
            RcrmAppAvailableResult.data &&
            RcrmAppAvailableResult.data.foundApp ? (
              <MenuItem route="/rmp-conversions/r-crm" text={t("__r_crm_conversions")} onClick={onBackdropClicked} />
            ) : (
              ""
            )}
            {(REACT_APP_ENABLE_GOOGLE == "TRUE" ||
              (businessInfoResult?.data?.business_id &&
                REACT_APP_ENABLE_GOOGLE_WHITELIST.search(businessInfoResult?.data?.business_id) >= 0)) && (
              <MenuItem
                route="/rmp-conversions/google-sheets"
                text={t("__google_sheets_conversions")}
                onClick={onBackdropClicked}
              />
            )}
          </>
        )}
      </>
    ) : (
      <>
        <MenuItem
          route="/dashboard/fb"
          text={t("__dashboard")}
          onClick={onBackdropClicked}
          padding="10px 10px 10px 11px"
        />
        <MenuItem
          route="/account-performance/fb"
          text={t("__account_performance")}
          onClick={onBackdropClicked}
          padding="10px 10px 10px 11px"
        />
        <MenuTitleZone>
          <TextTitle color={colors.subText} size="12px">
            {t("__conversion_header")}
          </TextTitle>
        </MenuTitleZone>
        <MenuItem
          route="/rmp-conversions/fb/r-widget"
          text={t("__fb_conversions_r_widget")}
          onClick={onBackdropClicked}
        />
        {RcrmAppAvailableResult &&
        RcrmAppAvailableResult.result === 0 &&
        RcrmAppAvailableResult.data &&
        RcrmAppAvailableResult.data.foundApp ? (
          <MenuItem route="/rmp-conversions/fb/r-crm" text={t("__fb_conversions_r_crm")} onClick={onBackdropClicked} />
        ) : (
          ""
        )}
        {(REACT_APP_ENABLE_GOOGLE == "TRUE" ||
          (businessInfoResult?.data?.business_id &&
            REACT_APP_ENABLE_GOOGLE_WHITELIST.search(businessInfoResult?.data?.business_id) >= 0)) && (
          <MenuItem
            route="/rmp-conversions/fb/google-sheets"
            text={t("__fb_conversions_google_sheets")}
            onClick={onBackdropClicked}
          />
        )}
      </>
    );
  if (windowSize.width < 835) {
    menuItems = (
      <>
        <MenuTitleZone>
          <TextTitle color={colors.subText} size="12px">
            Google
          </TextTitle>
        </MenuTitleZone>
        {authAdproResult.data.adwords_managed_service === "Y" ? (
          <>
            <MenuItem route="/dashboard" text={t("__dashboard")} onClick={() => onBackdropClicked("google")} />
            <MenuItem
              route="/adpro-suggestions"
              text={t("__adpro_suggestion")}
              onClick={() => onBackdropClicked("google")}
            />
            <MenuItem
              route="/account-performance"
              text={t("__account_performance")}
              onClick={() => onBackdropClicked("google")}
            />
            <MenuItem
              route="/search-campaigns"
              text={t("__search_campaign")}
              onClick={() => onBackdropClicked("google")}
            />
            <MenuItem
              route="/display-campaigns"
              text={t("__display_campaign")}
              onClick={() => onBackdropClicked("google")}
            />
            <MenuItem route="/payment" text={t("__payment")} onClick={() => onBackdropClicked("google")} />
            <MenuTitleZone>
              <TextTitle color={colors.subText} size="12px">
                {t("__conversion_header")}
              </TextTitle>
            </MenuTitleZone>
            <MenuItem
              route="/rmp-conversions/r-widget"
              text={t("__r_widget_conversions")}
              onClick={() => onBackdropClicked("google")}
              padding="10px 10px 10px 46px"
            />
            {RcrmAppAvailableResult &&
            RcrmAppAvailableResult.result === 0 &&
            RcrmAppAvailableResult.data &&
            RcrmAppAvailableResult.data.foundApp ? (
              <MenuItem
                route="/rmp-conversions/r-crm"
                text={t("__r_crm_conversions")}
                onClick={() => onBackdropClicked("google")}
                padding="10px 10px 10px 46px"
              />
            ) : (
              ""
            )}
            {(REACT_APP_ENABLE_GOOGLE == "TRUE" ||
              (businessInfoResult?.data?.business_id &&
                REACT_APP_ENABLE_GOOGLE_WHITELIST.search(businessInfoResult?.data?.business_id) >= 0)) && (
              <MenuItem
                route="/rmp-conversions/google-sheets"
                text={t("__google_sheets_conversions")}
                onClick={() => onBackdropClicked("google")}
                padding="10px 10px 10px 46px"
              />
            )}
          </>
        ) : (
          <>
            <MenuItem
              route="/dashboard/self-service"
              text={t("__dashboard")}
              onClick={() => onBackdropClicked("google")}
            />
            <MenuItem
              route="/account-performance/self-service"
              text={t("__account_performance")}
              onClick={() => onBackdropClicked("google")}
            />
            <MenuTitleZoneLevel2>
              <TextTitle color={colors.subText} size="12px">
                {t("__conversion_header")}
              </TextTitle>
            </MenuTitleZoneLevel2>
            <MenuItem
              route="/rmp-conversions/r-widget"
              text={t("__r_widget_conversions")}
              onClick={() => onBackdropClicked("google")}
              padding="10px 10px 10px 46px"
            />
            {RcrmAppAvailableResult &&
            RcrmAppAvailableResult.result === 0 &&
            RcrmAppAvailableResult.data &&
            RcrmAppAvailableResult.data.foundApp ? (
              <MenuItem
                route="/rmp-conversions/r-crm"
                text={t("__r_crm_conversions")}
                onClick={() => onBackdropClicked("google")}
                padding="10px 10px 10px 46px"
              />
            ) : (
              ""
            )}
            {(REACT_APP_ENABLE_GOOGLE == "TRUE" ||
              (businessInfoResult?.data?.business_id &&
                REACT_APP_ENABLE_GOOGLE_WHITELIST.search(businessInfoResult?.data?.business_id) >= 0)) && (
              <MenuItem
                route="/rmp-conversions/google-sheets"
                text={t("__google_sheets_conversions")}
                onClick={() => onBackdropClicked("google")}
                padding="10px 10px 10px 46px"
              />
            )}
          </>
        )}
        <MenuTitleZone>
          <TextTitle color={colors.subText} size="12px">
            Meta
          </TextTitle>
        </MenuTitleZone>
        <MenuItem route="/dashboard/fb" text={t("__dashboard")} onClick={() => onBackdropClicked("facebook")} />
        <MenuItem
          route="/account-performance/fb"
          text={t("__account_performance")}
          onClick={() => onBackdropClicked("facebook")}
        />
        <MenuTitleZoneLevel2>
          <TextTitle color={colors.subText} size="12px">
            {t("__conversion_header")}
          </TextTitle>
        </MenuTitleZoneLevel2>
        <MenuItem
          route="/rmp-conversions/fb/r-widget"
          text={t("__fb_conversions_r_widget")}
          onClick={() => onBackdropClicked("facebook")}
          padding="10px 10px 10px 46px"
        />
        {RcrmAppAvailableResult &&
        RcrmAppAvailableResult.result === 0 &&
        RcrmAppAvailableResult.data &&
        RcrmAppAvailableResult.data.foundApp ? (
          <MenuItem
            route="/rmp-conversions/fb/r-crm"
            text={t("__fb_conversions_r_crm")}
            onClick={onBackdropClicked}
            padding="10px 10px 10px 46px"
          />
        ) : (
          ""
        )}
        {(REACT_APP_ENABLE_GOOGLE == "TRUE" ||
          (businessInfoResult?.data?.business_id &&
            REACT_APP_ENABLE_GOOGLE_WHITELIST.search(businessInfoResult?.data?.business_id) >= 0)) && (
          <MenuItem
            route="/rmp-conversions/fb/google-sheets"
            text={t("__fb_conversions_google_sheets")}
            onClick={() => onBackdropClicked("facebook")}
            padding="10px 10px 10px 46px"
          />
        )}
        <MenuTitleZone>
          <TextTitle color={colors.subText} size="12px">
            {t("__settings_menu")}
          </TextTitle>
        </MenuTitleZone>
        <MenuItem route="/setting" text="Google" onClick={() => onBackdropClicked("settings")} />
        <MenuItem route="/setting/fb" text="Meta" onClick={() => onBackdropClicked("settings")} />
      </>
    );
  }

  if (windowSize.width > 834)
    return (
      <DesktopContainer radius="0px" padding="16px 0px">
        <AccountSelector />
        {menuItems}
      </DesktopContainer>
    );
  else
    return (
      <>
        <Backdrop onClick={onBackdropClicked} className={isVisible ? "-visible" : ""} />
        <MobileContainer className={isVisible ? "-visible" : ""}>
          <Header onSettingClick={onBackdropClicked} />
          {menuItems}
        </MobileContainer>
      </>
    );
};

Sidebar.propTypes = {
  isVisible: PropTypes.bool,
  onBackdropClicked: PropTypes.func,
};

export default Sidebar;

const MenuTitleZone = styled.div`
  padding: 24px 0 16px 16px;
`;

const MenuTitleZoneLevel2 = styled.div`
  padding: 10px 10px 10px 31px;
`;

const MenuItemLevel2 = styled.div`
  padding-left: 10px;
`;

const DesktopContainer = styled(Section)`
  position: absolute;
  width: 300px;
  border-radius: 10px;
`;

const MobileContainer = styled.div`
  background-color: ${colors.backgroundSection};
  position: absolute;
  top: 0;
  left: -100%;
  margin: 0 !important;
  height: 100vh;
  width: calc(100vw - 56px);
  overflow: auto;
  max-width: 300px;
  transition: left 0.5s;
  z-index: 999;

  &.-visible {
    left: 0;
  }
`;

const Backdrop = styled.div`
  @keyframes dimBG {
    from {
      background-color: transparent;
    }
    to {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }

  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  margin: 0 !important;
  display: none;
  z-index: 998;

  &.-visible {
    display: block;
    animation: dimBG 0.25s linear 1 forwards;
  }
`;
